import styled from "styled-components";
import {Text} from 'grommet';

const DottedText = styled(Text)`
    text-decoration-line: underline;
    text-decoration-style: dotted;
    cursor: pointer;
`;

export default DottedText;